import { get, post, put } from "./apiClient";
import { uriWithQueryStringParams } from "../utils/urlUtils";

export default {
  async list({ facilityId } = {}) {
    if (!facilityId) {
      throw new Error("Facility ID is required");
    }

    return await get(uriWithQueryStringParams("Employees", { facilityId }));
  },

  async getEmployeesByCustomerId(customerId) {
    return await get(`Employees/${encodeURIComponent(customerId)}`);
  },

  async getUniqueIdentifier(customerId) {
    return await get(`Employee/Identifier/${encodeURIComponent(customerId)}`);
  },

  async saveEmployee(employee) {
    if (employee.id) {
      return await put(`Employee`, employee);
    } else {
      return await post(`Employee`, employee);
    }
  },

  async get(employeeId) {
    return await get(`Employee/${encodeURIComponent(employeeId)}`);
  }
};
